import { gql } from '@apollo/client'
import { DXO_EXECUTION } from '../fragments/DXOExecution'

export const GET_DASHBOARD_PEER_RANKS = gql`
  query GetDashboardPeerRanks($input: DXOExecutionForUserInput!) {
    dashboardPeerRanks(input: $input) {
      results {
        ...DXOExecution
      }
      count
    }
  }
  ${DXO_EXECUTION}
`
